
import MultiSelect from '@/ui-kit/components/multi-select';
import { LISTING_STATUS_OPTIONS } from '../constants/options';
import { FilterCommonEventType } from '../enums';
import { StyleColorSchemeType, StyleSizeType } from '@/ui-kit/styles/enums';

export default {
  name: 'FilterListingStatus',
  components: {
    MultiSelect,
  },
  props: {
    className: {
      default: '',
      type: String,
    },
    value: {
      default: () => [],
      type: Array,
    },
    checkboxIconSize: {
      default: StyleSizeType.XSmall,
      type: String,
    },
    colorScheme: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    labelColorScheme: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    iconColor: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
  },
  data() {
    return {
      LISTING_STATUS_OPTIONS,
    };
  },
  methods: {
    handleChange(value) {
      this.$emit(FilterCommonEventType.Change, value);
    },
  },
};
